import { useMemo } from "react";
import { useOpenAiGlobal } from "./use-openai-global";

/**
 * Reads widget data from both toolOutput (model-visible) and
 * toolResponseMetadata (_meta, widget-only large data).
 * Merges them into a single object for backward compatibility.
 */
export function useWidgetProps<T extends Record<string, unknown>>(
  defaultState?: T | (() => T)
): T {
  const toolOutput = useOpenAiGlobal("toolOutput") as Record<string, unknown> | null;
  const toolResponseMetadata = useOpenAiGlobal("toolResponseMetadata") as Record<string, unknown> | null;

  const fallback =
    typeof defaultState === "function"
      ? (defaultState as () => T | null)()
      : defaultState ?? null;

  // Merge: toolOutput (kind, total, page) + toolResponseMetadata (listings, query, projects)
  const merged = useMemo(() => {
    if (!toolOutput && !toolResponseMetadata) {
      return fallback as T;
    }
    return {
      ...fallback,
      ...toolOutput,
      ...toolResponseMetadata,
    } as T;
  }, [toolOutput, toolResponseMetadata, fallback]);

  return merged;
}
